import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardLayout from "@/pages/DashboardLayout";
import Shops from "@/pages/Shops";
import Withdrawals from "@/pages/Withdrawals";
import WithdrawalDetail from "@/pages/WithdrawalDetail";
import Settings from "@/pages/Settings";
import EmailSettings from "@/pages/EmailSettings";
import Integrations from "@/pages/Integrations";
import Admin from "@/pages/Admin";
import PublicWithdrawalForm from "@/pages/PublicWithdrawalForm";
import Pricing from "@/pages/Pricing";
import Demo from "@/pages/Demo";
import BillingSuccess from "@/pages/BillingSuccess";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieBanner from "@/components/CookieBanner";

function PrivateRoute({ children }) {
    const { merchant, loading } = useAuth();
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen text-sm text-gray-500">
                Lädt...
            </div>
        );
    }
    if (!merchant) return <Navigate to="/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/demo" element={<Demo />} />
                            <Route path="/impressum" element={<Impressum />} />
                            <Route path="/datenschutz" element={<Datenschutz />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/w/:slug" element={<PublicWithdrawalForm />} />
                            <Route
                                path="/app"
                                element={
                                    <PrivateRoute>
                                        <DashboardLayout />
                                    </PrivateRoute>
                                }
                            >
                                <Route index element={<Navigate to="withdrawals" replace />} />
                                <Route path="shops" element={<Shops />} />
                                <Route path="withdrawals" element={<Withdrawals />} />
                                <Route path="withdrawals/:id" element={<WithdrawalDetail />} />
                                <Route path="billing" element={<Pricing embedded />} />
                                <Route path="billing/success" element={<BillingSuccess />} />
                                <Route path="settings" element={<Settings />} />
                                <Route path="email" element={<EmailSettings />} />
                                <Route path="integrations" element={<Integrations />} />
                                <Route path="admin" element={<Admin />} />
                            </Route>
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        <CookieBanner />
                    </BrowserRouter>
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
